/* tslint:disable:import-spacing */
/*
tslint:disable:typedef-whitespace tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}              from '@/util/i.command';
import {TSOChange}             from './t.s.o.change';
import {TSOSummaryTable}       from './t.s.o.summary.table';

/**
 *
 * @class SummaryTableSelectCommand
 *
 * @brief reversible selection changes for the summary table.  These are a little trickier,
 * because its combined with changes to the user input area.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SummaryTableSelectCommand implements ICommand {

  private oldValue: TSOChange;
  private newValue: TSOChange;
  private table:    TSOSummaryTable;

  constructor(oldValue: TSOChange, newValue: TSOChange, table: TSOSummaryTable) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.table    = table;
  }

  /** effect the command */
  execute() {

    this.table.doSelection(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.table.doSelection(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    const a = (this.oldValue instanceof TSOChange) ? this.oldValue.id : '';
    const b = (this.newValue instanceof TSOChange) ? this.newValue.id : '';

    return '[summarytable:select] ' + a + ' => ' + b;
  }

}
